// =============================================================================
// TOKENS DE PAGOS - SISTEMA DE DISEÑO TADMIN
// =============================================================================
// Tokens específicos para el sistema de pagos

import colors from './colors.js';
import typography from './typography.js';
import spacing from './spacing.js';
import shadows from './shadows.js';
import borders from './borders.js';

// =============================================================================
// TOKENS PARA SISTEMA DE PAGOS
// =============================================================================
export const paymentTokens = {
  // Cards de método de pago
  paymentCard: {
    default: {
      backgroundColor: colors.light.surface.default,
      border: borders.payment.paymentCard.default,
      borderRadius: borders.payment.paymentCard.default.radius,
      boxShadow: shadows.payment.paymentCard.default,
      padding: '16px',
    },
    selected: {
      border: borders.payment.paymentCard.selected,
      boxShadow: shadows.payment.paymentCard.selected,
    },
    error: {
      border: borders.payment.paymentCard.error,
      boxShadow: shadows.payment.paymentCard.error,
    },
  },
  
  // Formularios de pago
  paymentForm: {
    container: {
      backgroundColor: colors.light.surface.default,
      border: borders.payment.paymentForm.container,
      borderRadius: borders.payment.paymentForm.container.radius,
      boxShadow: shadows.payment.paymentForm.container,
      padding: '24px',
    },
    field: {
      border: borders.payment.paymentForm.field,
      borderRadius: borders.payment.paymentForm.field.radius,
      boxShadow: shadows.payment.paymentForm.field,
      padding: '10px 16px',
    },
  },
  
  // Estados de transacción
  transaction: {
    pending: {
      backgroundColor: colors.light.warning.light,
      border: borders.payment.transaction.pending,
      boxShadow: shadows.payment.transaction.pending,
      color: colors.light.warning.dark,
    },
    success: {
      backgroundColor: colors.light.success.light,
      border: borders.payment.transaction.success,
      boxShadow: shadows.payment.transaction.success,
      color: colors.light.success.dark,
    },
    failed: {
      backgroundColor: colors.light.error.light,
      border: borders.payment.transaction.failed,
      boxShadow: shadows.payment.transaction.failed,
      color: colors.light.error.dark,
    },
  },
};